//initial redux
import { put, call, takeEvery, fork, all, take, select } from "redux-saga/effects";
import * as router from "react-router-redux";
import { eventChannel, delay } from "redux-saga";
import reportsservice from "../../../../services/reports";
import moment from "moment-timezone";
import pointsservice from "../../../../services/points";
import {types as sitetreetypes} from "../../../../services/SiteTree/redux";


const initialState = {
};


/////////
//types
export const types = {
	LOAD_DATA: "components/dailyfailurechart/LOAD_DATA",
};

///////////
//reducers
export const reducers = {
	reducer(state = initialState, action) {
		switch (action.type) {
			case types.LOAD_DATA:{
				return state;
			}
			default:
				return state;
		}
	}
};

function addToChart(chart, dailyFailureSummaries){
	if(!chart.options){return;}
    let runTimeSeries = {
        type: 'column',
        data: [],
        name: 'Run Time',
        color: '#99A6CC',
        groupPadding: 0,
        borderWidth: 0,
        pointPadding: 0,
        tooltip: {
            pointFormatter: function(){
                return '<span style="color:{point.color}">\u25CF</span> ' + this.series.name + ': <b>' + (Math.floor(this.y)) + 'h ' + (Math.round(this.y * 60 % 60)) + 'm</b><br/>';
            },
		},
    };
    let failureTimeSeries = {
        type: 'column',
        data: [],
        name: 'Fail Time',
        color: 'rgb(232, 61, 59)',
        pointPadding: 0,
        groupPadding: 0,
        borderWidth: 0,
        tooltip: {
            pointFormatter: function(){
                return '<span style="color:{point.color}">\u25CF</span> ' + this.series.name + ': <b>' + (Math.floor(this.y)) + 'h ' + (Math.round(this.y * 60 % 60)) + 'm</b><br/>';
            },
		},
    };
    //set min max on chart
    chart.yAxis[0].setExtremes(0, 24);
    //we want the times as fractions of hours
    //also round to nearest minute because data can be a little off due to rounding on the server + this means labels can be displayed in terms of hours:minutes
    dailyFailureSummaries.forEach(dailyFailureSummary => {
        //round to nearest minute
        let runTimeMinutes = Math.round(dailyFailureSummary.runTimeSeconds / 60);
        let failTimeMinutes = Math.round(dailyFailureSummary.failTimeSeconds / 60);
        //value in terms of fractional hours i.e 5.34 hours
        let runTimeHours = runTimeMinutes / 60;
        let failTimeHours = failTimeMinutes / 60;
        runTimeSeries.data.push([dailyFailureSummary.dayStartSiteLocal.getTime(), runTimeHours]);
        failureTimeSeries.data.push([dailyFailureSummary.dayStartSiteLocal.getTime(), failTimeHours]);
    });

    chart.addSeries(runTimeSeries, false);
    chart.addSeries(failureTimeSeries);
}

//////////
//sagas
export const sagas = {
	*rootSaga() {
		yield all([ this.loadData()]);
    },
  
	*loadData(){
		yield takeEvery(types.LOAD_DATA, function*({payload}){
			const component = payload.component;
			const chart = payload.chart;
			const ruleInstanceId = component.ruleInstanceId;
			//const fromDate = moment(payload.timePeriod.startDate);
			//const toDate = moment(payload.timePeriod.endDate);
			let currentSite = yield select(x => x.sitetree.currentSite);
			if(!currentSite){
				yield take(sitetreetypes.ON_LOAD);
				currentSite = yield select(x => x.sitetree.currentSite);
			}
			let utcOffset = 0;
            if(currentSite && currentSite.momentTimezone){
                utcOffset = moment().tz(currentSite.momentTimezone).utcOffset();
            }
            let fromDate = moment().utc().subtract(1, 'years').add(utcOffset, 'm');
            let toDate = moment().utc().add(utcOffset, 'm');
			
			const dailyFailureSummaries = yield call(reportsservice.GetDailyFailureSummary, ruleInstanceId, fromDate, toDate);
			if(dailyFailureSummaries instanceof Error || !dailyFailureSummaries || !dailyFailureSummaries.length){
				return;
			}
            addToChart(chart, dailyFailureSummaries);
            if(payload.onLoadComplete){
                payload.onLoadComplete();
            }
		});
	},
};

////////
//actions
export const actions = {
	loadData(component, chart, timePeriod, onLoadComplete){
		return {
			type: types.LOAD_DATA,
			payload: {component, chart, timePeriod, onLoadComplete}
		};
	},
};



// WEBPACK FOOTER //
// ./src/components/ReportComponents/Charts/DailyFailureChart/redux.js